import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import {LoginService} from '../../../login-service';

@Component({
  selector: 'app-skills1',
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.scss']
})
export class SkillsComponent implements OnInit {
skillName:any;
skillDesc:any;
usertype:string
skillid:any;
addSkill:boolean=false;
skillsList:any;
message:any;
type:any;
pager: {
  totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number;
  endPage: number; startIndex: number; endIndex: number;
  pages: number[];
};
searchWord: string = "";
pagedItems: any;
SearchList:any;

currentpage: number=1;

searchText: any;
viewed:boolean=false;
skillsListDetails:any;
  MenuPermissions: string;
  userID: string;
  roleID: string;
  menuData: any;
  menuName: any;
  menuID: any;
  rolesList: any;
  selectedSkillsListid=[];
  checked:boolean=false;
  dynamicRows: number=8;
  rowsOnPageSet: any=[];
  rowCount: any;
  rowsOnPage: any;
  p:any;
  count:any;
savefilter: any;
  constructor(private loginService:LoginService) {

    this.userID=localStorage.getItem("userID");
    this.roleID=localStorage.getItem("roleID");
    // this.menuData=localStorage.getItem("menuData");
    this.MenuPermissions=localStorage.getItem("MenuPermissions");
    
    this.usertype=localStorage.getItem("userTypeid")
    
    this.GetMenusByUserType(3);
   
   }

  ngOnInit(): void {
    console.log(this.rowsOnPage);
    this.rowsOnPage=8
    this.loginService.getselectpage(10)
    this.getSkills();
    this.GetRoles();
  }
  
/*Display add skills form*/
  Addskills(){
    this.addSkill=true;
    this.type="New";
  }
  
  cancelSkills(){
this.addSkill=false;
  }
/* Retrieve skills records from the database*/
  getSkills(){
    
    this.loginService.Getskills(3).subscribe(data=>
      {
        this.skillsList = JSON.parse(data['_body']);;
        this.skillsListDetails=this.skillsList;
        this.savefilter=this.skillsListDetails;
        this.assigndynamicarray(this.savefilter)
        if(this.skillsListDetails.length>0){
          this.setPage(1);
        }

      
      });
   
 } 
 assigndynamicarray(skillsList)
 {
   console.log(skillsList)
   this.dynamicRows=10;
   this.rowsOnPageSet=[];
   this.rowCount = skillsList.length;
   console.log(this.rowCount,this.dynamicRows)
   while (this.dynamicRows < this.rowCount) {
     this.rowsOnPageSet.push(this.dynamicRows);
     this.dynamicRows = this.dynamicRows + 10;
     console.log(this.rowsOnPageSet)
   }
   if (!this.rowsOnPageSet.includes(this.rowCount))
     this.rowsOnPageSet.push(this.rowCount);
   if (this.rowsOnPageSet.length === 1) {
     if (this.rowsOnPageSet[0] <= 10)
       this.rowsOnPage = this.rowsOnPageSet[0];
   }
   this.rowsOnPage = this.rowsOnPageSet[0];
 }
 selectRow(id,e){
   if(e.target.checked){
    this.selectedSkillsListid.push(e.target.id)
   }
   else{
    var index = this.selectedSkillsListid.indexOf(e.target.id);
   this.selectedSkillsListid.splice(index,1)
   }
 }
 DeleteSelected(){
  if(this.selectedSkillsListid.length==0){
    return;
  }
  else{
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete the selected rows' ,///
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.deleterows(this.selectedSkillsListid);//
      } else if (result.dismiss === Swal.DismissReason.cancel) {
  
      }
    })
  }
 }
 deleterows(list){
for(var i=0;i<list.length;i++){
  this.delete(list[i],'d');
  this.selectedSkillsListid=[];
}
 }
Searchtext(){
  this.skillsList = this.skillsListDetails;
  
      let tempCompany = this.skillsListDetails.filter(
        (item) => {
          return (
            (item.skillname !== null && item.skillname.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
            (item.description !== null && item.description.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
         
          );
        }
  
      );
      this.skillsList = tempCompany;
     
      // if(this.searchText=="")
      // {
      //  this.getSkills();
      //  this.assigndynamicarray(this.skillsList)
      // }
      if(this.searchText !== ""){
        this.skillsListDetails = tempCompany;
        this.assigndynamicarray(tempCompany)
        this.setPage(1);
    }else{
        this.skillsListDetails = this.savefilter;      
        this.assigndynamicarray(this.skillsListDetails)
  
        this.setPage(1);
    }
     
}
GetRoles(){
  this.loginService.GetRoles(this.usertype).subscribe(data=>
    {  
            this.rolesList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
let filteRole=this.rolesList.filter(x=>x.RoleID.toString()==this.roleID.toString())

if(filteRole.length>0){
  this.MenuPermissions=JSON.parse(filteRole[0].MenuJson);
  
}
});
}
GetMenusByUserType(userTypeID){
  this.loginService.GetMenusByUserType(userTypeID).subscribe(data=>
      {
  
  this.menuData=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
 
  let tempdata=this.menuData;
  
  this.menuData=tempdata.filter(x=>x.menu_name.toString().toLowerCase()==='skills');
  
  if(this.menuData.length>0)
    {
  this.menuName=this.menuData[0]["menu_name"];
  this.menuID=this.menuData[0]["menu_id"];
    }
  

    
  
      });
      }
      changepagination(page:number){
        this.count=this.rowsOnPage
        console.log(this.rowsOnPage)
        this.loginService.getselectpage(this.rowsOnPage)
        this.loginService.getPager(this.skillsListDetails.length, page);
        this.setPage(page)
      }

 setPage(page: number) {

   this.p=page;
  this.pager = this.loginService.getPager(this.skillsListDetails.length, page);
  this.count=this.pager.pageSize
  this.pagedItems = this.skillsListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
  this.skillsList = this.skillsListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);

}

/*Save and update skills in the database*/
 saveSkills(){
   if(this.skillName==""||this.skillName==undefined)
   {
      return;
   }
  const json={
    skillidparm:this.skillid,
   skillname:this.skillName,
   descriptionparam:this.skillDesc,
   updatedbyparm:"Admin",
   createdbyparm:'Admin'
  };
 

   if(this.skillName===" "|| this.skillName===undefined){
    return;
   }
   else{
 

  this.loginService.SaveSkills(json).subscribe((dataJson) => {
   
   if (dataJson['_body'].toString() === 'true') {
    if(this.type== "New"){
      // Swal.fire("Saved Successfully");
      this.loginService.showSuccess("Saved successfully!",'');
      setTimeout(() => {
        this.message = "";
      }, 5000);
      }
      else if(this.type==="Edit"){
        // Swal.fire("Updated Successfully");
        this.loginService.showSuccess("Updated successfully!",'');
      }
      
   
  
   setTimeout(() => {
     this.message = "";
   }, 5000);
   
   this.getSkills();
   //this.setPage(1);
 }
 if(this.type=="New"){
   this.skillName="";
   this.skillDesc="";
 }

this.getSkills();
   });
  }
   
}
/*Display edit form */
edit(row){
 
  this.type="Edit";
  this.addSkill=true;
 this.skillid=row.id;
  this.skillName=row.skillname;
  this.skillDesc=row.description;
  
}
/*View the skill details in the form*/
viewskill(row){
  
  this.type="View";
  this.addSkill=true;
  this.viewed=true;
  this.skillName=row.skillname;
  this.skillDesc=row.description;
}
/* Delete a record from the skills table by passing its id*/
deleteskill(row,isactive,text){
  event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to '+text+' this skill:' + row.skillname,///
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      this.delete(row.id,isactive);//
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })

}

delete(ID,isactive) {
  const json={
    skillidparm:ID,
    isactive:isactive
  }
  this.loginService.DeleteSkill(json).subscribe(data => { 
   //  Swal.fire("Deleted successfully")    
           if(isactive=='d'){
          this.loginService.showSuccess("Deleted Successfully","");

        }
       else if(isactive=='y'){
        this.loginService.showSuccess("Activated Successfully","");

       }
       else{
        this.loginService.showSuccess("Deactivated Successfully","");

       }
    this.getSkills();
    setTimeout(() => {
      this.message = "";
    }, 1000);
  
  })
}


}
